import DashboardLayout from "src/pages/Layout/DashboardLayout.vue";
import AuthLayout from "src/pages/Auth/AuthLayout2.vue";
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";
import LandRegistration from "src/pages/Register/Land/LandRegister.vue";
import VesselRegistration from "src/pages/Register/Vessel/VesselRegister.vue";
import VesselRegistration1 from "src/pages/Register/Vessel/VesselRegister-1.vue";
import VendorRegistration from "src/pages/Register/Vendor/VendorRegister.vue";
import VendorRegistration1 from "src/pages/Register/Vendor/VendorRegister-1.vue";
import VendorRegistration2 from "src/pages/Register/Vendor/VendorRegister-2.vue";
import AuthoritiesRegistration from "src/pages/Register/Authorities/AuthoritiesRegister.vue";

const ForgotPassword = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Auth/ForgotPassword.vue"
  );
const RecoverPassword = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Auth/RecoverPassword.vue"
  );

// landing
const Overview = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard/Dashboard.vue"
  );
//Admin pages
const HomeOverview = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Incoming.vue"
  );

const GenerateQR = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/GenerateQR.vue"
  );

const HomePreprocess = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Preprocess.vue"
  );

const HomeInventory = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Inventory2.vue"
  );

const HomeInventoryList = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/InventoryList.vue"
  );

const HomeOutgoing = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Outgoing.vue"
  );

const OutgoingCreateJob = () =>
  import(
      /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Outgoing/CreateJob.vue"
  );

const OutgoingJobPage = () =>
  import(
      /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Outgoing/OutgoingJobPage.vue"
  );

const CollectionSchedule = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Outgoing/Schedule.vue"
  );

const HomeUsers = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Users.vue"
  );

const AddUsers = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/AddUser.vue"
  );

const AddContractor = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/AddContractor.vue"
  );

const HomeCalendar = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Calendar2.vue"
  );

const HomeForms = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Forms.vue"
  );

const HomeReports = () =>
  import(
      /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Reports.vue"
  );

const Report1 = () =>
  import(
        /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/VesselGeneratedWaste.vue"
  );

const Report2 = () =>
  import(
          /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/GarbageWCO.vue"
  );

const Report3 = () =>
  import(
            /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/ScrapWCO.vue"
  );

const Report4 = () =>
  import(
              /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/SWWCO.vue"
  );

const Report5 = () =>
  import(
                /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/TyreWCO.vue"
  );
const Report6 = () =>
  import(
                  /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/WDO.vue"
  );

const Report7 = () =>
  import(
                    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/WDR.vue"
  );

const Report8 = () =>
  import(
                      /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/WCOOverall.vue"
  );

const Report9 = () =>
  import(
                        /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/VesselsBerthVolume.vue"
  );

const Report10 = () =>
  import(
                          /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Report/RevenueSharing.vue"
  );
const JobPage = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Incoming/JobPage.vue"
  );

const ScrapJobPage = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Incoming/ScrapJobPage.vue"
  );

const GarbageJobPage = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Incoming/GarbageJobPage.vue"
  );

const TyreJobPage = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Incoming/TyreJobPage.vue"
  );

const OtherJobPage = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Incoming/OtherJobPage.vue"
  );

const EditPage = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Incoming/EditPage.vue"
  );

const JobPage1 = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Preprocess/JobPage/JobPage.vue"
  );

const JobPage2 = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Preprocess/JobPage/JobPage1.vue"
  );

//Land pages
const LandOverview = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/Overview.vue"
  );

const LandRequest = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/Job.vue"
  );

const LandRequestJob = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/RequestJob.vue"
  );

const LandCalendar = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/Schedule.vue"
  );

const LandForm = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/Form.vue"
  );

const LandReview = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/Review.vue"
  );

//Vessel pages
const VesselOverview = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/Overview.vue"
  );

const VesselRequest = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/Job.vue"
  );

const VesselRequestJob = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/RequestJob.vue"
  );

const VesselCalendar = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/Schedule.vue"
  );

const VesselForm = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/Form.vue"
  );

const VesselReview = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/Review.vue"
  );

// Vendor pages
const VendorOverview = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vendor/Overview.vue"
  );

const VendorJob = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vendor/Job.vue"
  );

const VendorJobPage = () =>
  import(
      /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vendor/JobPage.vue"
  );

const VendorSchedule = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vendor/Schedule.vue"
  );

//Authorities pages
const AuthoritiesOverview = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Authorities/Overview.vue"
  );

const AuthoritiesJob = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Authorities/Job.vue"
  );

const AuthoritiesSchedule = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Authorities/Schedule.vue"
  );

const SalesPage = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Sales.vue"
  );

//Setting pages
const Setting = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Setting/Setting.vue");

const Profile = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Profile/Profile.vue");

const LandSale = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/Sales.vue");

const Browseproduct = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/BrowseProduct.vue");

const Cart = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/Cart.vue");

const Request = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Land/Buy.vue");

const VesselSale = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/Sales.vue");

const VesselBrowseproduct = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/BrowseProduct.vue");

const VesselCart = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/Cart.vue");

const VesselRequestItem = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Vessel/Buy.vue");

const OutgoingJob = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Admin/Outgoing/JobPage.vue");

import Widgets from "src/pages/Widgets.vue";

let forgotpasswordRoute = {
  path: "forgotpassword",
  name: "Forgot Password",
  components: AuthLayout,
};

let recoverpasswordRoute = {
  path: "recoverpassword",
  name: "Recover Password",
  components: AuthLayout,
};

//admin route
let adminMenu = {
  path: "/admin",
  component: DashboardLayout,
  redirect: "/admin",
};

let loginRoute = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
};

const routes = [
  {
    path: "/",
    redirect: "/login",
    name: "Login",
  },
  {
    path: "/forgotpassword",
    name: "Forgot Password",
    components: { default: ForgotPassword },
  },
  {
    path: "/recoverpassword",
    name: "Recover Password",
    components: { default: RecoverPassword },
  },
  // {
  //   path: "/",
  //   name: "Registration",
  //   children: [
  //     {
  //       path: "Registration/Land",
  //       component: {
  //         default: LandRegistration,
  //       },
  //     },
  //   ],
  // },
  loginRoute,
  forgotpasswordRoute,
  recoverpasswordRoute,
  adminMenu,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/overview",
    name: "Dashboard",
    meta: { requiresAuth: true },
    children: [
      {
        path: "overview",
        name: "Home",
        components: { default: Overview },
        meta: { requiresAuth: true },
      },
      {
        path: "Incoming",
        name: "Incoming",
        components: { default: HomeOverview },
        meta: { requiresAuth: true },
      },
      {
        path: "Sales",
        name: "Sales",
        components: { default: SalesPage },
        meta: { requiresAuth: true },
      },
      {
        path: "Incoming/:refnum",
        name: "Incoming",
        components: { default: GenerateQR },
        meta: { requiresAuth: true },
      },
      {
        path: "JobPage/:jobnum",
        name: "Job Page",
        components: { default: JobPage },
        meta: { requiresAuth: true },
      },
      {
        path: "ScrapJobPage/:jobnum",
        name: "Job Page",
        components: { default: ScrapJobPage },
        meta: { requiresAuth: true },
      },
      {
        path: "GarbageJobPage/:jobnum",
        name: "Job Page",
        components: { default: GarbageJobPage },
        meta: { requiresAuth: true },
      },
      {
        path: "TyreJobPage/:jobnum",
        name: "Job Page",
        components: { default: TyreJobPage },
        meta: { requiresAuth: true },
      },
      {
        path: "OtherJobPage/:jobnum",
        name: "Job Page",
        components: { default: OtherJobPage },
        meta: { requiresAuth: true },
      },

      {
        path: "EditPage",
        name: "Edit Page",
        components: { default: EditPage },
        meta: { requiresAuth: true },
      },
      {
        path: "Preprocess",
        name: "Pre-processing",
        components: { default: HomePreprocess },
        meta: { requiresAuth: true },
      },
      {
        path: "JobPage1/:pagename/:refno/:action",
        name: "Pre-Processing",
        components: { default: JobPage1 },
        meta: { requiresAuth: true },
      },
      {
        path: "JobPage2",
        name: "Pre-Processing",
        components: { default: JobPage2 },
        meta: { requiresAuth: true },
      },
      {
        path: "Inventory",
        name: "Inventory Overview",
        components: { default: HomeInventory },
        meta: { requiresAuth: true },
      },
      {
        path: "InventoryList",
        name: "Inventory List",
        components: { default: HomeInventoryList },
        meta: { requiresAuth: true },
      },
      {
        path: "Outgoing",
        name: "Outgoing",
        components: { default: HomeOutgoing },
        meta: { requiresAuth: true },
      },
      {
        path: "Outgoing/:refno",
        name: "Outgoing",
        components: { default: OutgoingJob },
        meta: { requiresAuth: true },
      },
      {
        path: "Outgoing/CreateJob/:jobnum/:action",
        name: "Outgoing",
        components: { default: OutgoingCreateJob },
        meta: { requiresAuth: true },
      },
      {
        path: "OutgoingJobPage/:jobnum/:action",
        name: "Outgoing",
        components: { default: OutgoingJobPage },
        meta: { requiresAuth: true },
      },
      {
        path: "CollectionSchedule",
        name: "Job",
        components: { default: CollectionSchedule },
        meta: { requiresAuth: true },
      },
      {
        path: "Users",
        name: "User Management",
        components: { default: HomeUsers },
        meta: { requiresAuth: true },
      },
      {
        path: "AddUser/:module/:actionflag/:viewflag",
        name: "New User Registration",
        components: { default: AddUsers },
        meta: { requiresAuth: true },
      },
      {
        path: "AddContractor/:id/:viewflag",
        name: "New Contractor Registration",
        components: { default: AddContractor },
        meta: { requiresAuth: true },
      },
      {
        path: "Calendar",
        name: "Calendar",
        components: { default: HomeCalendar },
        meta: { requiresAuth: true },
      },
      {
        path: "Forms",
        name: "Forms",
        components: { default: HomeForms },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports",
        name: "Reports",
        components: { default: HomeReports },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/VesselGeneratedWaste",
        name: "Reports",
        components: { default: Report1 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/GarbageWCO",
        name: "Reports",
        components: { default: Report2 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/ScrapWCO",
        name: "Reports",
        components: { default: Report3 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/SWWCO",
        name: "Reports",
        components: { default: Report4 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/TyreWCO",
        name: "Reports",
        components: { default: Report5 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/WDO",
        name: "Reports",
        components: { default: Report6 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/WDR",
        name: "Reports",
        components: { default: Report7 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/WCOOverall",
        name: "Reports",
        components: { default: Report8 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/VesselsBerthVolume",
        name: "Reports",
        components: { default: Report9 },
        meta: { requiresAuth: true },
      },
      {
        path: "Reports/RevenueSharing",
        name: "Reports",
        components: { default: Report10 },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/Overview",
        name: "LandOverview",
        components: { default: LandOverview },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/Request",
        name: "LandRequest",
        components: { default: LandRequest },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/RequestJob/:jobnum/:action",
        name: "LandRequestJob",
        components: { default: LandRequestJob },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/Calendar",
        name: "LandCalendar",
        components: { default: LandCalendar },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/Sales",
        name: "Sales",
        components: { default: LandSale },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/BrowseProduct",
        name: "Sales",
        components: { default: Browseproduct },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/Cart",
        name: "Sales",
        components: { default: Cart },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/RequestItem",
        name: "Sales",
        components: { default: Request },
        meta: { requiresAuth: true },
      },

      {
        path: "Land/Form",
        name: "LandForm",
        components: { default: LandForm },
        meta: { requiresAuth: true },
      },
      {
        path: "Land/Review/:jobnum",
        name: "LandReview",
        components: { default: LandReview },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/Overview",
        name: "VesselOverview",
        components: { default: VesselOverview },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/Request",
        name: "LandRequest",
        components: { default: VesselRequest },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/RequestJob/:jobnum/:action",
        name: "LandRequestJob",
        components: { default: VesselRequestJob },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/Sales",
        name: "Sales",
        components: { default: VesselSale },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/BrowseProduct",
        name: "Sales",
        components: { default: VesselBrowseproduct },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/Cart",
        name: "Sales",
        components: { default: VesselCart },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/RequestItem",
        name: "Sales",
        components: { default: VesselRequestItem },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/Calendar",
        name: "LandCalendar",
        components: { default: VesselCalendar },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/Form",
        name: "VesselForm",
        components: { default: VesselForm },
        meta: { requiresAuth: true },
      },
      {
        path: "Vessel/Review/:jobnum",
        name: "VesselReview",
        components: { default: VesselReview },
        meta: { requiresAuth: true },
      },
      {
        path: "Vendor/Overview",
        name: "VendorOverview",
        components: { default: VendorOverview },
        meta: { requiresAuth: true },
      },
      {
        path: "Vendor/Job",
        name: "VendorJob",
        components: { default: VendorJob },
        meta: { requiresAuth: true },
      },
      {
        path: "Vendor/Job/:outgoingid/:action",
        name: "VendorJobPage",
        components: { default: VendorJobPage },
        meta: { requiresAuth: true },
      },
      {
        path: "Vendor/Schedule",
        name: "VendorSchedule",
        components: { default: VendorSchedule },
        meta: { requiresAuth: true },
      },
      {
        path: "Authorities/Overview",
        name: "AuthoritiesOverview",
        components: { default: AuthoritiesOverview },
        meta: { requiresAuth: true },
      },
      {
        path: "Authorities/Job",
        name: "AuthoritiesJob",
        components: { default: AuthoritiesJob },
        meta: { requiresAuth: true },
      },
      {
        path: "Authorities/Schedule",
        name: "AuthoritiesSchedule",
        components: { default: AuthoritiesSchedule },
        meta: { requiresAuth: true },
      },
      {
        path: "/setting",
        name: "Setting",
        component: Setting,
        meta: { requiresAuth: true },
      },
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/land-register",
    name: "LandRegistration",
    component: LandRegistration,
  },
  {
    path: "/vessel-register",
    name: "VesselRegistration",
    component: VesselRegistration,
  },
  {
    path: "/vessel-register-1",
    name: "VesselRegistration-1",
    component: VesselRegistration1,
  },
  {
    path: "/vendor-register",
    name: "VendorRegistration",
    component: VendorRegistration,
  },
  {
    path: "/vendor-register-1",
    name: "VendorRegistration-1",
    component: VendorRegistration1,
  },
  {
    path: "/vendor-register-2",
    name: "VendorRegistration-2",
    component: VendorRegistration2,
  },
  {
    path: "/authorities-register",
    name: "Authorities Registration",
    component: AuthoritiesRegistration,
  },

  { path: "*", component: NotFound },
];

export default routes;
